import { selectAuthToken } from '../state/tokenSlice';
import { useSelector } from 'react-redux';

const useAuthToken = () => useSelector(selectAuthToken);

export default useAuthToken;
